import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Clock } from "lucide-react";
import { COLORS } from "@/lib/api";

const ComingSoon = ({ section, sub }) => {
  const accent = COLORS[section.color] || COLORS.magenta;
  const title = sub ? sub.title : section.title;

  return (
    <div
      data-testid="coming-soon"
      className="min-h-[70vh] flex items-center justify-center px-6 py-20"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-xl text-center"
      >
        <img src="/logo.png" alt="Juventudes Latentes" className="w-20 h-20 mx-auto rounded-2xl shadow-lg" />

        <span
          className="mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] font-semibold px-4 py-1.5 rounded-full text-white"
          style={{ background: accent }}
        >
          <Clock size={13} /> {section.title}
        </span>

        <h1 className="mt-6 font-heading text-4xl md:text-5xl font-bold tracking-tight text-brand-ink">
          {title}
        </h1>
        <p className="mt-4 text-2xl md:text-3xl font-heading font-semibold text-gradient">
          Próximamente disponible
        </p>
        <p className="mt-4 text-brand-ink/70 leading-relaxed">
          Estamos preparando esta sección con mucho cuidado. Muy pronto encontrarás aquí todo el
          contenido. ¡Gracias por tu interés en Juventudes Latentes!
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            data-testid="coming-soon-home"
            className="inline-flex items-center gap-2 bg-brand-ink text-white font-semibold px-6 py-3 rounded-sm hover:bg-brand-orange transition-colors duration-200"
          >
            <ArrowLeft size={17} /> Volver al inicio
          </Link>
          <Link
            to="/contacto"
            data-testid="coming-soon-contact"
            className="inline-flex items-center gap-2 border border-brand-ink text-brand-ink font-semibold px-6 py-3 rounded-sm hover:bg-brand-ink hover:text-white transition-colors duration-200"
          >
            Contáctanos
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default ComingSoon;
